import { render } from "./add-buyer.vue?vue&type=template&id=57ea92a4&lang=pug"
import script from "./add-buyer.vue?vue&type=script&setup=true&lang=js"
export * from "./add-buyer.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__